import React from 'react';
import SelectRC from 'react-select';

export default class Select extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: null
        };
    }

    handleChange(val) {
        this.setState({value: val}, () => {
            this.props.handleChange(this.state.value);
        });
    }

    componentDidMount() {
        if (this.props.value) {
            this.setState({value: this.props.value});
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({value: newProps.value});
    }

    render() {
        return (
            <div className="form-group">
                <SelectRC
                    name={String(this.props.item.name)}
                    placeholder={this.props.item.title}
                    multi
                    joinValues
                    value={this.state.value}
                    options={this.props.item.options}
                    onChange={(val) => this.handleChange(val)}
                    className="Select-bootstrap"
                />
            </div>
        );
    }
}